import axios from "./../helper/axiosIntance";
import { normalizeStringInObject } from "../utils/normalize";

function getFormData(object) {
  const formData = new FormData();
  if (object) {
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
  }
  return formData;
}
const register = (params) => {
  return axios.post(
    "/user/api/register",
    getFormData(normalizeStringInObject(params))
  );
};
const addUser = (params) => {
  return axios.post("/user/api/addUser", normalizeStringInObject(params));
};
const view = (params) => {
  return axios.post(
    "/user/api/view",
    getFormData(normalizeStringInObject(params))
  );
};

const view2 = (params) => {
  if (params.exportStaff) {
    return axios.post("/user/api/view2", normalizeStringInObject(params), {
      responseType: "blob",
    });
  }
  return axios.post("/user/api/view2", normalizeStringInObject(params));
};
const edit = (params) => {
  return axios.post(`/user/api/edit`, normalizeStringInObject(params));
};
const delete_force = (params) => {
  return axios.post(
    `/user/api/delete`,
    getFormData(normalizeStringInObject(params))
  );
};
//tien

const findone_user = (params) => {
  return axios.post(
    `/user/api/findoneUser`,
    getFormData(normalizeStringInObject(params))
  );
};

const findone_user_by_id = (params) => {
  return axios.post(
    `/user/api/findOneUserById`,
    getFormData(normalizeStringInObject(params))
  );
};

const edit_info_profile = (params) => {
  return axios.post(
    `/user/api/editInfoProfile`,
    getFormData(normalizeStringInObject(params))
  );
};

const edit_config_sip = (params) => {
  return axios.post(
    `/user/api/editConfigSip`,
    getFormData(normalizeStringInObject(params))
  );
};

const change_password = (params) => {
  return axios.post(
    `/user/api/changePassword`,
    getFormData(normalizeStringInObject(params))
  );
};
const update_setting = (params) => {
  return axios.post(
    `/user/api/updateSetting`,
    getFormData(normalizeStringInObject(params))
  );
};
const forget_pass = (params) => {
  return axios.post(
    `/auth/api/forget_pass`,
    getFormData(normalizeStringInObject(params))
  );
};
const confirm_forget_pass = (params) => {
  return axios.post(
    `/auth/api/confirm_forget_pass`,
    getFormData(normalizeStringInObject(params))
  );
};
const find_name_by_id = (params) => {
  return axios.post(
    `/user/api/getInfoUser`,
    getFormData(normalizeStringInObject(params))
  );
};
const confirm_decree = (params) => {
  return axios.post(`/user/api/confirmDecree`, normalizeStringInObject(params));
};
const check_confirm_decree = (params) => {
  return axios.post(
    `/user/api/checkConfirmDecree`,
    normalizeStringInObject(params)
  );
};
const find_tags = (params) => {
  return axios.post(`/user/api/findListTags`, normalizeStringInObject(params));
};
const insert_tags = (params) => {
  return axios.post(`/user/api/insertTags`, normalizeStringInObject(params));
};
const edit_tags = (params) => {
  return axios.post(`/user/api/editTags`, normalizeStringInObject(params));
};
const delete_tags = (params) => {
  return axios.post(`/user/api/deleteTags`, normalizeStringInObject(params));
};
const find_and_map_tags_by_arr_id = (params) => {
  return axios.post(`/user/api/findAndMapTagsByArrId`, normalizeStringInObject(params));
};
export default {
  register,
  addUser,
  view,
  edit,
  delete_force,
  edit_info_profile,
  findone_user,
  change_password,
  view2,
  edit_config_sip,
  update_setting,
  forget_pass,
  confirm_forget_pass,
  find_name_by_id,
  confirm_decree,
  check_confirm_decree,
  findone_user_by_id,
  find_tags,
  insert_tags,
  edit_tags,
  delete_tags,
  find_and_map_tags_by_arr_id
};
